import { Component } from '@angular/core';

@Component({
    selector: 'sku',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class SkuComponent {}
